export default "__VITE_ASSET__kJbw0RAS__"